import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { WidgetsModule } from '../widgets/widgets.module';
import { ManagePaymentModalContextComponent } from './manage-payment-modal-context/manage-payment-modal-context.component';
import { ConfirmMessageModalComponent } from './confirm-message-modal/confirm-message-modal.component';
import { ConfirmPasswordModalComponent } from './confirm-password-modal/confirm-password-modal.component';
import { InformationMessageModalComponent } from './information-message-modal/information-message-modal.component';
import { AddActivatedNumberModalComponent } from './add-activated-number-modal/add-activated-number-modal.component';
import { InputModalComponent } from './input-modal/input-modal.component';
import { RoutingModalComponent } from './routing-modal/routing-modal.component';
import { EditCcModalComponent } from './edit-cc-modal/edit-cc-modal.component';
import { SelectCCModalComponent } from './select-payment-modal/select-payment-modal.component';
import { ShippingAddressModalComponent } from './shipping-address-modal/shipping-address-modal.component';
import { SimReplacementModalComponent } from './sim-replacement-modal/sim-replacement-modal.component';
import { FiveGModalComponent } from './fiveg-modal/fiveg-modal.component';
import { PhoneNotImpactedModalComponent } from './phone-not-impacted-modal/phone-not-impacted-modal.component';
import { SwiperModule } from 'swiper/angular';
import { AlertSecurityModalComponent } from './alert-security-modal/alert-security-modal.component';
import { IosDataSetupModalComponent } from './ios-data-setup-modal/ios-data-setup-modal.component';
import { CompatibilitySkipModalComponent } from './skip-device-modal/skip-device-modal.component';
import { eSimReplacementModalComponent } from './esim-replacement-modal/esim-replacement-modal.component';
import { TrackingModalComponent } from './tracking-details-modal/tracking-details-modal.component';
import { successModalComponent } from './success-modal/success-modal.component';
import { InstractionsFiveGIos17ModalComponent } from './instractions-five-g-ios17-modal/instractions-five-g-ios17-modal.component';
import { GoogleLoginComponent } from './google-login/google-login.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { RecaptchaVerificationComponent } from './recaptcha-verification/recaptcha-verification.component';
import { IldCountriesComponent } from './ild-countries/ild-countries.component';
import { WifiCallingModalComponent } from './wifi-calling-modal/wifi-calling-modal.component';
import { emailVerificationModalComponent } from './email-verification-needed-modal/email-verification-needed-modal.component';
import { STRIPE_PAYMENT_CONFIG, StripePaymentComponent, StripePaymentConfig, WidgetAddressLookupComponent } from '@ztarmobile/zwp-widgets';
import { IntCallingListModalComponent } from './int-calling-list-modal/int-calling-list-modal.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatTabsModule } from '@angular/material/tabs';
import { InternationalCallingModule } from '@app/support/international-calling/international-calling.module';
import { PriceTableComponent } from './int-calling-list-modal/price-table/price-table.component';
import { FailureModalComponent } from './failure-modal/failure-modal.component';
import { ChangePinModalComponent } from './change-pin-modal/change-pin-modal.component';
import { ClipboardModule } from 'ngx-clipboard';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { ChangeNameModalComponent } from './change-name-modal/change-name-modal.component';
import { ChangeEmailModalComponent } from './change-email-modal/change-email-modal.component';
import { AddPaymentCardModalComponent } from './add-payment-card-modal/add-payment-card-modal.component';
import { PUBLISHER_KEY } from '@env/environment';
import { AddAddressModalComponent } from './add-address-modal/add-address-modal.component';
import { PayGoListModalComponent } from './pay-go-list-modal/pay-go-list-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';

@NgModule({
	declarations: [
		PriceTableComponent,
		ConfirmMessageModalComponent,
		ManagePaymentModalContextComponent,
		PhoneNotImpactedModalComponent,
		AddActivatedNumberModalComponent,
		ConfirmPasswordModalComponent,
		InformationMessageModalComponent,
		InputModalComponent,
		RoutingModalComponent,
		EditCcModalComponent,
		SelectCCModalComponent,
		ShippingAddressModalComponent,
		SimReplacementModalComponent,
		FiveGModalComponent,
		WifiCallingModalComponent,
		eSimReplacementModalComponent,
		AlertSecurityModalComponent,
		IosDataSetupModalComponent,
		CompatibilitySkipModalComponent,
		TrackingModalComponent,
		successModalComponent,
		InstractionsFiveGIos17ModalComponent,
		GoogleLoginComponent,
		RecaptchaVerificationComponent,
		IldCountriesComponent,
		emailVerificationModalComponent,
		IntCallingListModalComponent,
		FailureModalComponent,
		ChangePinModalComponent,
		ChangePasswordModalComponent,
		ChangeNameModalComponent,
		ChangeEmailModalComponent,
		AddPaymentCardModalComponent,
		AddAddressModalComponent,
		PayGoListModalComponent,
		ErrorModalComponent
	],
	imports: [
		SwiperModule,
		CommonModule,
		WidgetsModule,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
		GoogleSigninButtonModule,
		WidgetAddressLookupComponent,
		MatTabsModule,
		NgxPaginationModule,
		ClipboardModule,
		StripePaymentComponent
	],
	exports: [
		ConfirmMessageModalComponent,
		ManagePaymentModalContextComponent,
		PhoneNotImpactedModalComponent,
		ShippingAddressModalComponent,
		AddActivatedNumberModalComponent,
		ConfirmPasswordModalComponent,
		InformationMessageModalComponent,
		InputModalComponent,
		RoutingModalComponent,
		EditCcModalComponent,
		SelectCCModalComponent,
		SimReplacementModalComponent,
		eSimReplacementModalComponent,
		WifiCallingModalComponent,
		IosDataSetupModalComponent,
		CompatibilitySkipModalComponent,
		TrackingModalComponent,
		successModalComponent,
		InstractionsFiveGIos17ModalComponent,
		GoogleLoginComponent,
		RecaptchaVerificationComponent,
		IldCountriesComponent,
		emailVerificationModalComponent,
		IntCallingListModalComponent,
		FailureModalComponent,
		ChangePinModalComponent,
		ChangePasswordModalComponent,
		ChangeNameModalComponent,
		ChangeEmailModalComponent,
		AddPaymentCardModalComponent,
		AddAddressModalComponent
	],
	providers: [
		{
			provide: STRIPE_PAYMENT_CONFIG,
			useValue: {
				publisherKey: PUBLISHER_KEY
			} as StripePaymentConfig
		},
		PayGoListModalComponent
	]
})
export class ModalsModule {
}
